
export default {
    "重庆市巴南区政府":"重庆市<br/>巴南区政府",
    "浙江江山市文旅局":"浙江江山市<br/>文旅局",
    "深圳市宝安区规划局":"深圳市<br/>宝安区规划局",
    "西宁市南川新区管委会":"西宁市<br/>南川新区管委会",
}